import { useHistory } from 'react-router-dom';
import { List, ListItem, ListItemIcon, ListItemText, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  taskContainer: {
    marginTop: '12px',
    width: '100%',
    background: '#FFFFFF',
    justifyContent: 'center',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    borderRadius: '2px',
  },
  listContainer: {
    overflow: 'auto',
  },
  listItem: {
    width: '95%',
    margin: 'auto',
    background: '#F1FCFF',
    boxSizing: 'border-box',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.25)',
    borderRadius: '2px',
    marginBottom: '20px',
    marginTop: '20px',
    padding: '15px',
  },
  listTagContainer: {
    alignSelf: 'center',
  },

  taskTitle: { display: 'flex', zIndex: -0.5 },

  title: {
    fontWeight: 600,
  },
  userIcon: {
    color: '#096094',
    position: 'relative',
  },
}));

export default function AdminActions() {
  const classes = useStyles();
  const history = useHistory();

  return (
    <>
      <Typography className={classes.title} variant="h5">
        Actions
      </Typography>
      <div className={classes.taskContainer}>
        <List className={classes.listContainer}>
          <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/admin/estates`)}
          >
            <ListItemIcon>
              <img src="/concierge-manager.svg" alt="Estates-Trusuite-Search" />
            </ListItemIcon>
            <ListItemText primary="Trusuite Queue" />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/admin/tasks`)}
          >
            <ListItemIcon>
              <img src="/concierge-manager.svg" alt="Tasks" />
            </ListItemIcon>
            <ListItemText primary="Task Queue" />
          </ListItem>
          {/* <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/home/referrals`)}
          >
            <ListItemIcon>
              <img src="/person-box-icon.svg" alt="Corporate Referrals" />
            </ListItemIcon>
            <ListItemText primary="Manage Corporate Referrals" />
          </ListItem> */}
          {/* <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/home/concierges`)}
          >
            <ListItemIcon>
              <img src="/concierge-manager.svg" alt="Concierge Accounts" />
            </ListItemIcon>
            <ListItemText primary="Manage Concierge Accounts" />
          </ListItem> */}
          {/* <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/home/coupons`)}
          >
            <ListItemIcon>
              <img src="/concierge-manager.svg" alt="Coupons" />
            </ListItemIcon>
            <ListItemText primary="Manage Coupons" />
          </ListItem> */}
          <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/home/estate-result-rules`)}
          >
            <ListItemIcon>
              <img src="/concierge-manager.svg" alt="Estate Result Rules" />
            </ListItemIcon>
            <ListItemText primary="Suspected Account Logic" />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/home/estate-task-templates`)}
          >
            <ListItemIcon>
              <img src="/concierge-manager.svg" alt="Estate Task Templates" />
            </ListItemIcon>
            <ListItemText primary="Master Task List" />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/home/manage-document-tags`)}
          >
            <ListItemIcon>
              <img src="/concierge-manager.svg" alt="" />
            </ListItemIcon>
            <ListItemText primary="Document Tags" />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/home/manage-required-information-format`)}
          >
            <ListItemIcon>
              <img src="/concierge-manager.svg" alt="" />
            </ListItemIcon>
            <ListItemText primary="Data Keys" />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/home/manage-document-generation-templates`)}
          >
            <ListItemIcon>
              <img src="/concierge-manager.svg" alt="" />
            </ListItemIcon>
            <ListItemText primary="Templates" />
          </ListItem>
          <ListItem
            button
            className={classes.listItem}
            disableRipple
            onClick={() => history.push(`/home/manage-conditional-template-question-sets`)}
          >
            <ListItemIcon>
              <img src="/concierge-manager.svg" alt="" />
            </ListItemIcon>
            <ListItemText primary="Conditional Question Sets" />
          </ListItem>
        </List>
      </div>
    </>
  );
}
